import React from "react";

class LocalStorageCleaner extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      UST: [],
      SoRo: true,
      Visited : [],
      OutVisited : []
    };
  }
  async componentDidMount() {
    const UST = JSON.parse(localStorage.getItem("DailyData"));
    const Visited = JSON.parse(localStorage.getItem("VisitIn"));
    const OutVisited = JSON.parse(localStorage.getItem("backupVisits"));

    await this.setState({ UST: UST , Visited : Visited , OutVisited : OutVisited});

    //     const { intervalInDays } = this.props;
    //     const millisecondsInDay = 24 * 60 * 60 * 1000;
    //     const intervalInMilliseconds = intervalInDays * millisecondsInDay;

    //     let lastCleanedTimestamp = localStorage.getItem('lastCleanedTimestamp');
    //     const currentTimeStamp = new Date().getTime();

    //     if (!lastCleanedTimestamp) {
    //         lastCleanedTimestamp = currentTimeStamp;
    //         localStorage.setItem('lastCleanedTimestamp', lastCleanedTimestamp.toString());
    //     }

    //     const timeSinceLastClean = currentTimeStamp - lastCleanedTimestamp;
    //     const numberOfIntervalsPassed = Math.floor(timeSinceLastClean / intervalInMilliseconds);
    //     console.log(numberOfIntervalsPassed);
    //     for (let i = 0; i < numberOfIntervalsPassed; i++) {
    //         this.cleanLocalStorage();
    //     }

    //     const nextCleaningTimestamp = lastCleanedTimestamp + numberOfIntervalsPassed * intervalInMilliseconds;
    //     const timeToNextCleaning = nextCleaningTimestamp - currentTimeStamp;

    //     this.intervalId = setTimeout(() => {
    //         this.cleanLocalStorage();
    //         localStorage.setItem('lastCleanedTimestamp', currentTimeStamp.toString());
    //     }, timeToNextCleaning);
    // }

    // componentWillUnmount() {
    //     clearTimeout(this.intervalId);
    // }

    // cleanLocalStorage = () => {
    //     localStorage.setItem("DailyData", JSON.stringify([]));
    await this.timezone();
  }

  timezone = async () => {
    const date = new Date();
    console.log(date);
    // let day = date.getDate();
    // let month = date.getMonth() + 1;
    // let year = date.getFullYear();
    // let currentDate = `${year}-${month}-${day}`;

    date.setDate(date.getDate() - 10);
    console.log(date.getTime());
    // await this.setState({
    //   dateIn: year + "-" + month + "-" + day,
    //   timeIn: hours + ":" + minutes + ":" + seconds,
    //   disableDate: true,
    // });
    var temp = [];
    var temp1 = [];
    var temp2 = [];
    if (
      this.state.UST !== undefined &&
      this.state.UST !== null &&
      this.state.UST.length !== 0 &&
      this.state.UST[0] !== null &&
      this.state.UST[0] !== undefined
    ) {
      await this.state.UST[0].map(async (type) => {
        //  console.log(SO.date_order.substring(0, 10))
        // var date_test = new Date(type.date_order.replace(/-/g, "/"));
        var date_test = new Date(type.date_order);
        date_test.setDate(date_test.getDate());
        console.log(date_test.getTime());

        if (date_test.getTime() > date.getTime()) {
          temp.push(type);
        }
      });
      this.state.UST[0] = temp;
      await localStorage.setItem("DailyData", JSON.stringify(this.state.UST));
    }
    if (
      this.state.Visited !== undefined &&
      this.state.Visited !== null &&
      this.state.Visited.length !== 0
    ) {
      await this.state.Visited.map(async (type) => {
        //  console.log(SO.date_order.substring(0, 10))
        // var date_test = new Date(type.date_order.replace(/-/g, "/"));
        var date_test = new Date(type.dateIn);
        date_test.setDate(date_test.getDate());
        console.log(date_test.getTime());

        if (date_test.getTime() > date.getTime()) {
          temp1.push(type);
        }
      });
      this.state.Visited = temp1;
      await localStorage.setItem("VisitIn", JSON.stringify(this.state.Visited));
    }

    if (
      this.state.OutVisited !== undefined &&
      this.state.OutVisited !== null &&
      this.state.OutVisited.length !== 0
    ) {
      await this.state.OutVisited.map(async (type) => {
        //  console.log(SO.date_order.substring(0, 10))
        // var date_test = new Date(type.date_order.replace(/-/g, "/"));
        var date_test = new Date(type.dateVisitIn);
        date_test.setDate(date_test.getDate());
        console.log(date_test.getTime());

        if (date_test.getTime() > date.getTime()) {
          temp2.push(type);
        }
      });
      this.state.Visited = temp2;
      await localStorage.setItem("backupVisits", JSON.stringify(this.state.OutVisited));
    }
  };

  render() {
    return null;
  }
}

export default LocalStorageCleaner;
